import { ConditionValueInputComponent } from 'Automations/nodeDefinitions/conditions'
import { NumberInputField } from 'Automations/nodeDefinitions/components'
import { clampNumeric } from './clampNumeric'

/**
 * Percentage input with a `%` suffix, clamped to 0–100 on blur.
 */
export const PercentageInput: ConditionValueInputComponent = ({
  'data-testid': dataTestId,
  value,
  onChange,
  validationErrors
}) => (
  <NumberInputField
    data-testid={dataTestId ? `${dataTestId}.value` : undefined}
    value={value}
    placeholder="0.00"
    textAlign="right"
    suffix="%"
    onChange={e => onChange({ value: e.target.value })}
    onBlur={() => {
      const clamped = clampNumeric(value, { min: 0, max: 100 })
      onChange({ value: String(clamped) })
    }}
    validationErrors={validationErrors}
  />
)
